import { Typography, TypographyVariant } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import {
  ColorDynamic,
  Column,
  Columns,
  Inline,
  Stack,
} from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { formatCurrency, formatPlural } from 'shared/helpers/IntlHelpers';
import { ResponsiveTooltip } from 'shared/ui/ResponsiveTooltip';
import styled from 'styled-components';
import { trackLoadboardEvent } from '../LoadboardAnalytics';
import { CargoInsuranceMinimumDTO } from './data/CargoInsuranceMinimumDTO';

const Line = styled.div`
  height: 5px;
  width: 100%;
  min-width: 8px;
  margin-bottom: 4px;
  border-bottom: 1px dotted ${ColorDynamic.Dark100};
`;

interface CargoInsuranceMinimumTooltipProps {
  limits: CargoInsuranceMinimumDTO[];
  titleVariant?: TypographyVariant | 'inherit';
}

export function CargoInsuranceMinimumTooltip({
  limits,
  titleVariant,
}: CargoInsuranceMinimumTooltipProps) {
  const lastIndex = limits.length - 1;

  if (limits.length === 1) {
    return (
      <Typography variant={titleVariant} color="textPrimary">
        Cargo Insurance Minimum
      </Typography>
    );
  }

  return (
    <ResponsiveTooltip
      placement="top"
      onOpen={() => {
        trackLoadboardEvent({ name: 'Carrier Viewed Cargo Minimum Details' });
      }}
      title={
        <Stack>
          {limits.map((limit, index) => (
            <Columns key={limit.trailer_size} space="xxsmall" align="bottom">
              <Column width="content">
                <Typography noWrap={true}>
                  {limit.trailer_size}
                  {lastIndex === index ? '+' : ''}{' '}
                  {formatPlural(limit.trailer_size, 'unit', 'units')}
                </Typography>
              </Column>
              <Column width="fluid">
                <Line />
              </Column>
              <Column width="content">
                <Typography noWrap={true}>
                  {formatCurrency(limit.cargo_limit || 0, {
                    minimumFractionDigits: 0,
                  })}
                </Typography>
              </Column>
            </Columns>
          ))}
        </Stack>
      }
    >
      <Box>
        <Inline verticalAlign="center">
          <Typography variant={titleVariant} color="textPrimary">
            Cargo Insurance Minimum
          </Typography>
          <Info color="action" fontSize="small" />
        </Inline>
      </Box>
    </ResponsiveTooltip>
  );
}
